import React, { useState, useEffect } from 'react';

const slides = [
  {
    id: 1,
    image: '/org/top/top01e.jpg',
    alt: 'WiCanvas Professional Display Solutions',
  },
  {
    id: 2,
    image: '/org/top/top02e.png',
    alt: 'Multiple Display Scenes in Office Environment',
  },
  {
    id: 3,
    image: '/org/top/top03e.png',
    alt: 'Smart Installation & Management System',
  },
];

export const HeroCarousel: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <section className="hero">
      <div className="hero-carousel">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}
          >
            <img src={slide.image} alt={slide.alt} className="slide-image" />
          </div>
        ))}
      </div>
      <div className="hero-content">
        <div className="container">
          <h1 className="hero-title">
            WiCanvasで実現する<br />
            <span className="highlight">次世代ワイヤレスディスプレイ</span>
          </h1>
          <p className="hero-subtitle">
            配線不要、簡単設置で空間をスマートに演出。<br />
            あらゆるシーンで活躍する革新的なディスプレイソリューション
          </p>
          <div className="hero-buttons">
            <a href="#products" className="btn btn-primary btn-large">
              製品を見る
            </a>
            <a href="#contact" className="btn btn-outline btn-large">
              お問い合わせ
            </a>
          </div>
        </div>
      </div>
      <div className="carousel-indicators">
        {slides.map((_, index) => (
          <span
            key={index}
            className={`indicator ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            style={{ cursor: 'pointer' }}
          />
        ))}
      </div>
    </section>
  );
};
